// import React, { useState, useEffect } from "react";
// import { useNavigate } from "react-router-dom";
// import axios from "axios";

// const AddAdmin = () => {
//     const [formData, setFormData] = useState({
//       membershipId: "",
//       adminName: "",
//       lomName: "", // This stores the lomId, but we display the lomName
//       contactNumber: "",
//     });
//     const [errors, setErrors] = useState({});
//     const [loms, setLoms] = useState([]); // State to store LOM options
//     const navigate = useNavigate();
  
//     // Validation function
//     const validateForm = () => {
//       const newErrors = {};
//       if (!formData.membershipId.trim()) newErrors.membershipId = "Membership ID is required";
//       if (!formData.adminName.trim()) newErrors.adminName = "Admin Name is required";
//       if (!formData.lomName.trim()) newErrors.lomName = "LOM Name is required";
//       if (!formData.contactNumber.trim() || !/^[6-9]\d{9}$/.test(formData.contactNumber))
//         newErrors.contactNumber = "Valid contact number is required";
  
//       setErrors(newErrors);
//       return Object.keys(newErrors).length === 0; // Returns true if no errors
//     };
  
//     // Handle form submission
//     const handleSubmit = (e) => {
//       e.preventDefault();
    
//       if (validateForm()) {
//         // Simulate API call
//         axios
//           .post("/member/create", {
//             membershipId: formData.membershipId,
//             adminName: formData.adminName,
//             lomId: formData.lomName,  // Send the selected lomId to the API
//             contactNumber: formData.contactNumber,
//             type : '3',
//           })
//           .then((response) => {
//             // Assuming the API returns a success message
//             alert(response.data.message);  // Display success message
    
//             // Reset form
//             setFormData({ membershipId: "", adminName: "", lomName: "", contactNumber: "" });
//             setErrors({});
    
//             // Navigate back to the dashboard after submitting
//             navigate("/super_admin_dashboard");
//           })
//           .catch((error) => {
//             // Handle error response
//             console.error("Error:", error);
//             alert("There was an error adding the admin. Please try again.");
//           });
//       }
//     };
  
//     // Handle input change
//     const handleChange = (e) => {
//       const { name, value } = e.target;
//       setFormData({ ...formData, [name]: value });
//     };
  
//     // Fetch LOM data on component mount
//     useEffect(() => {
//       axios
//         .get(`/lom/get_all1`)
//         .then(response => {
//           const data = Array.isArray(response.data) ? response.data : [response.data]; // Ensure data is an array
//           setLoms(data);
//         })
//         .catch(error => console.error('Error fetching LOMs:', error));
//     }, []);
  
//     return (
//       <div className="min-h-screen bg-gray-100">
//         {/* Top Navigation Bar */}
//         <nav className="flex items-center justify-between bg-blue-600 text-white p-4 shadow-lg">
//           <h1 className="text-lg font-bold">Add Admin</h1>
//           <button
//             className="bg-blue-800 hover:bg-blue-700 text-white py-2 px-4 rounded shadow-md"
//             onClick={() => navigate("/super_admin_dashboard")} // Navigate back to the dashboard
//           >
//             Back to Dashboard
//           </button>
//         </nav>
  
//         {/* Main Content */}
//         <main className="p-6">
//           <form
//             className="bg-white rounded-lg shadow p-6 max-w-lg mx-auto"
//             onSubmit={handleSubmit}
//           >
//             <h2 className="text-2xl font-semibold mb-4">Add Admin</h2>
  
//             {/* Membership ID */}
//             <div className="mb-4">
//               <label className="block text-gray-700 font-bold mb-2">Membership ID</label>
//               <input
//                 type="text"
//                 name="membershipId"
//                 value={formData.membershipId}
//                 onChange={handleChange}
//                 className="w-full px-4 py-2 border rounded shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-600"
//               />
//               {errors.membershipId && <p className="text-red-500 text-sm">{errors.membershipId}</p>}
//             </div>
  
//             {/* Admin Name */}
//             <div className="mb-4">
//               <label className="block text-gray-700 font-bold mb-2">Admin Name</label>
//               <input
//                 type="text"
//                 name="adminName"
//                 value={formData.adminName}
//                 onChange={handleChange}
//                 className="w-full px-4 py-2 border rounded shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-600"
//               />
//               {errors.adminName && <p className="text-red-500 text-sm">{errors.adminName}</p>}
//             </div>
  
//             {/* LOM Name (Dropdown) */}
//             <div className="mb-4">
//               <label className="block text-gray-700 font-bold mb-2">LOM Name</label>
//               <select
//                 name="lomName"
//                 value={formData.lomName}
//                 onChange={handleChange}
//                 className="w-full px-4 py-2 border rounded shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-600"
//               >
//                 <option value="">Select LOM</option>
//                 {loms.map((lom) => (
//                   <option key={lom.lom_id} value={lom.lom_id}>
//                     {lom.lom_name}
//                   </option>
//                 ))}
//               </select>
//               {errors.lomName && <p className="text-red-500 text-sm">{errors.lomName}</p>}
//             </div>
  
//             {/* Contact Number */}
//             <div className="mb-4">
//               <label className="block text-gray-700 font-bold mb-2">Contact Number</label>
//               <input
//                 type="text"
//                 name="contactNumber"
//                 value={formData.contactNumber}
//                 onChange={handleChange}
//                 className="w-full px-4 py-2 border rounded shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-600"
//               />
//               {errors.contactNumber && <p className="text-red-500 text-sm">{errors.contactNumber}</p>}
//             </div>
  
//             {/* Submit Button */}
//             <button
//               type="submit"
//               className="w-full bg-blue-600 hover:bg-blue-700 text-white py-2 px-4 rounded shadow-md"
//             >
//               Submit
//             </button>
//           </form>
//         </main>
//       </div>
//     );
//   };
  
//   export default AddAdmin;
  


import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";

const AddAdmin = () => {
    const [formData, setFormData] = useState({
      membershipId: "",
      adminName: "",
      lomName: "", // This stores the lomId, but we display the lomName
      contactNumber: "",
    });
    const [errors, setErrors] = useState({});
    const [loms, setLoms] = useState([]); // State to store LOM options
    const navigate = useNavigate();
  
    // Validation function
    const validateForm = () => {
      const newErrors = {};
      if (!formData.membershipId.trim()) newErrors.membershipId = "Membership ID is required";
      if (!formData.adminName.trim()) newErrors.adminName = "Admin Name is required";
      if (!formData.lomName.trim()) newErrors.lomName = "LOM Name is required";
      if (!formData.contactNumber.trim() || !/^[6-9]\d{9}$/.test(formData.contactNumber))
        newErrors.contactNumber = "Valid contact number is required";
  
      setErrors(newErrors);
      return Object.keys(newErrors).length === 0; // Returns true if no errors
    };
  
    // Handle form submission
    const handleSubmit = (e) => {
      e.preventDefault();
    
      if (validateForm()) {
        // Simulate API call
        axios
          .post("/member/create", {
            membershipId: formData.membershipId,
            adminName: formData.adminName,
            lomId: formData.lomName,  // Send the selected lomId to the API
            contactNumber: formData.contactNumber,
            type : '3',
          })
          .then((response) => {
            // Assuming the API returns a success message
            alert(response.data.message);  // Display success message
    
            // Reset form
            setFormData({ membershipId: "", adminName: "", lomName: "", contactNumber: "" });
            setErrors({});
    
            // Navigate back to the dashboard after submitting
            navigate("/super_admin_dashboard");
          })
          .catch((error) => {
            // Handle error response
            console.error("Error:", error);
            alert("There was an error adding the admin. Please try again.");
          });
      }
    };
  
    // Handle input change
    const handleChange = (e) => {
      const { name, value } = e.target;
      setFormData({ ...formData, [name]: value });
    };
  
    // Fetch LOM data on component mount
    useEffect(() => {
      axios
        .get(`/lom/get_all1`)
        .then(response => {
          const data = Array.isArray(response.data) ? response.data : [response.data]; // Ensure data is an array
          setLoms(data);
        })
        .catch(error => console.error('Error fetching LOMs:', error));
    }, []);
  
    return (
      <div className="min-h-screen bg-gray-100">
  
        {/* Main Content */}
        <main className="p-6">
          <form
            className="bg-white rounded-lg shadow p-6 max-w-lg mx-auto"
            onSubmit={handleSubmit}
          >
            <h2 className="text-2xl font-semibold mb-4">Add Admin</h2>
  
            {/* Membership ID */}
            <div className="mb-4">
              <label className="block text-gray-700 font-bold mb-2">Membership ID</label>
              <input
                type="text"
                name="membershipId"
                value={formData.membershipId}
                onChange={handleChange}
                className="w-full px-4 py-2 border rounded shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-600"
              />
              {errors.membershipId && <p className="text-red-500 text-sm">{errors.membershipId}</p>}
            </div>
  
            {/* Admin Name */}
            <div className="mb-4">
              <label className="block text-gray-700 font-bold mb-2">Admin Name</label>
              <input
                type="text"
                name="adminName"
                value={formData.adminName}
                onChange={handleChange}
                className="w-full px-4 py-2 border rounded shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-600"
              />
              {errors.adminName && <p className="text-red-500 text-sm">{errors.adminName}</p>}
            </div>
  
            {/* LOM Name (Dropdown) */}
            <div className="mb-4">
              <label className="block text-gray-700 font-bold mb-2">LOM Name</label>
              <select
                name="lomName"
                value={formData.lomName}
                onChange={handleChange}
                className="w-full px-4 py-2 border rounded shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-600"
              >
                <option value="">Select LOM</option>
                {loms.map((lom) => (
                  <option key={lom.lom_id} value={lom.lom_id}>
                    {lom.lom_name}
                  </option>
                ))}
              </select>
              {errors.lomName && <p className="text-red-500 text-sm">{errors.lomName}</p>}
            </div>
  
            {/* Contact Number */}
            <div className="mb-4">
              <label className="block text-gray-700 font-bold mb-2">Contact Number</label>
              <input
                type="text"
                name="contactNumber"
                value={formData.contactNumber}
                onChange={handleChange}
                className="w-full px-4 py-2 border rounded shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-600"
              />
              {errors.contactNumber && <p className="text-red-500 text-sm">{errors.contactNumber}</p>}
            </div>
  
            {/* Submit Button */}
            <button
              type="submit"
              className="w-full bg-blue-600 hover:bg-blue-700 text-white py-2 px-4 rounded shadow-md"
            >
              Submit
            </button>
          </form>
        </main>
      </div>
    );
  };
  
  export default AddAdmin;
  
  
  